export default "__VITE_ASSET__Bpe6zBxU__"